"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoringType = void 0;
exports.getScoringTypes = getScoringTypes;
exports.getScoringTypeFrom = getScoringTypeFrom;
var ScoringType;
(function (ScoringType) {
    ScoringType["Passage"] = "passage";
    ScoringType["Matrix"] = "matrix";
    ScoringType["Rating"] = "rating";
    ScoringType["Auto"] = "auto";
})(ScoringType || (exports.ScoringType = ScoringType = {}));
function getScoringTypes() {
    return Object.values(ScoringType);
}
function getScoringTypeFrom(value) {
    return getScoringTypes().find(function (type) { return type === value; });
}
